import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Typography, Button } from 'antd';
import ModalStatusMessage from '../typograhpy/ModalStatusMessage';
import { db, COLLECTION_BOOKING_DATES_REF } from '../../firebase';
import logger from '../../services/logger';
import { convertTimestampToMoment } from '../../utils';


const propTypes = {
    visible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

const { Title, Text, Paragraph } = Typography;

const createInitialState = props => ({
    visible: props.visible,
    isLoading: false,
    error: null,
    success: false,
    submitted: false,
});

class AdminDeleteHolidayModal extends Component {
    state = createInitialState(this.props);

    componentDidUpdate(prevProps) {
        const { visible } = this.props;

        if (prevProps.visible !== visible) {
            this.setState({ visible: visible });
        }
    }

    handleDelete = async () => {
        this.setState({ isLoading: true });

        try {
            const { doc } = this.props;

            const bookingDateTimeRef = await db.collection(COLLECTION_BOOKING_DATES_REF).doc(doc.id);

            await bookingDateTimeRef.delete();

            this.setState({ success: true, submitted: true });
        } catch (e) {
            this.handleError(e);
        }
    }

    handleError = (error = null) => {
        logger.error(error);

        this.setState({ error: true, submitted: true });
    }

    handleClose = () => {
        const initialState = createInitialState(this.props);

        this.setState({ ...initialState });

        this.props.handleClose();
    }

    renderFooter = () => {
        const {
            isLoading,
            success,
            error
        } = this.state;

        if (error || success) return null;

        return (
            <>
                <Button onClick={this.handleClose}>
                    Cancel
                </Button>
                <Button
                    type="primary"
                    loading={isLoading}
                    onClick={this.handleDelete}
                >
                    Yes, delete holiday
                </Button>
            </>
        );
    }

    render() {
        const { success, submitted, visible } = this.state;
        const { doc } = this.props;

        if (!doc) return null;

        const momentObj = convertTimestampToMoment(doc.date_time);

        return (
            <Modal
                title={null}
                visible={visible}
                onCancel={this.handleClose}
                footer={this.renderFooter()}
                destroyOnClose
            >
                {
                    submitted
                    ? <ModalStatusMessage
                        message={ success ? 'Holiday successfully deleted.' : 'There was an error processing this request.' }
                        variant={ success ? 'success' : 'error' }
                        handleClose={this.handleClose}
                    />
                    : <>
                        <Title level={4}>
                            Are you sure you want to delete this holiday?
                        </Title>
                        <br />

                        <div>
                            <Paragraph>
                                <Text strong>Selected Holiday: </Text>{ momentObj.format('dddd, MMMM Do YYYY') }
                            </Paragraph>
                            <Paragraph>
                                Deleting this holiday will allow customers to create bookings on this date. Are you sure you want to delete this holiday?
                            </Paragraph>
                        </div>
                    </>
                }
            </Modal>
        );
    }
}

AdminDeleteHolidayModal.propTypes = propTypes;

export default AdminDeleteHolidayModal;
